import { EnvironmentConfig } from '~/config'

export const CES_SURVEY_ID = EnvironmentConfig.USERFLOW_SURVEYS.TALENTSEARCH
export const SKILL_SEARCH_LIMIT = 7
